import React, { useEffect, useRef, useMemo } from 'react';
import { useCart, buildCartOrders } from '@/Context/CartContext';
import { useQueryClient } from '@tanstack/react-query';
import { API } from '@/Services/apiConfig';
import { useMenuSlotQuery } from '@/hooks/useMenuQueries';

const CartSSEWatcher: React.FC = () => {
    const { cartItems, setInvalidItemIds } = useCart();
    const cartOrders = useMemo(() => buildCartOrders(cartItems), [cartItems]);
    const esRef = useRef<EventSource | null>(null);
    const queryClient = useQueryClient();

    // Globally fetch menu slot to validate cart items against the selected date
    const { data } = useMenuSlotQuery(null, cartOrders);

    useEffect(() => {
        if (data?.invalidCartItemIds) {
            setInvalidItemIds(new Set(data.invalidCartItemIds));
        }
    }, [data?.invalidCartItemIds, setInvalidItemIds]);

    useEffect(() => {
        if (esRef.current) return;

        const url = new URL(API.MENU_STREAM, window.location.origin);
        const es = new EventSource(url.pathname + url.search);
        esRef.current = es;

        es.addEventListener('menu_changed', () => {
            queryClient.invalidateQueries({ queryKey: ['menu'] });
        });

        return () => {
            es.close();
            esRef.current = null;
        };
    }, [queryClient]);

    return null;
};

export default CartSSEWatcher;
